export const UPDATE_SIDE_PANEL = "UI/SIDE_PANEL/UPDATE";
